let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3k1jA")).then(() => parcelRequire('jyVCM'));